import React, { useEffect, useState } from 'react';
import { IonApp } from '@ionic/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/theme.scss';

/* Navigator */
import AppStackNavigator, {
  LABORATORY_GROUP_HOMEPAGE,
  APPOINTMENT_CHECKIN,
  APPOINTMENT_CHECKIN_COVID,
  SCAN_RESULT_ROUTE
} from './navigators/AppStackNavigator';

/* State Store */
import { Provider } from 'react-redux';
import { configureStore } from './store';
import SnackBarNotifications from './components/SnackBarNotifications';
import PWAToast from './components/PWAToast';
import ThemeProvider from './components/theme/ThemeProvider';
import { setHomeLink } from './store/actions/laboratory';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './services/msal/msal.services';
import RGPDToast from './components/RGPDToast';
import AuthenticationWrapper from './components/AuthenticationWrapper';

export const store = configureStore({});

const App: React.FC = () => {
  const [showRGPD, setShowRGPD] = useState(true);

  useEffect(() => {
    const isLabPage = window.location.pathname.includes(
      LABORATORY_GROUP_HOMEPAGE
    );
    const isCheckin = window.location.pathname.includes(APPOINTMENT_CHECKIN);
    const isCheckinCovid = window.location.pathname.includes(
      APPOINTMENT_CHECKIN_COVID
    );
    if (isLabPage || isCheckin || isCheckinCovid) {
      store.dispatch(setHomeLink(window.location.pathname));
    } else {
      store.dispatch(setHomeLink('/'));
    }
    if (window.location.pathname.includes(SCAN_RESULT_ROUTE)) {
      setShowRGPD(false);
    }
  }, []);

  return (
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <ThemeProvider>
          <IonApp>
            <AuthenticationWrapper>
              <SnackBarNotifications />
              <PWAToast />
              {showRGPD ? <RGPDToast /> : null}
              <AppStackNavigator />
            </AuthenticationWrapper>
          </IonApp>
        </ThemeProvider>
      </MsalProvider>
    </Provider>
  );
};

export default App;

// store
// .dispatch(fetchActivities('reactjs'))
// .then(() => console.log(store.getState()));
